export const ITEMS_PER_PAGE = 40;

export enum FILTER_TYPE {
  ALL = 'All',
  ART = 'Profiles',
  CULTURE = 'Culture',
  SERVICE = 'Service',
}

export const FILTER_ITEMS = [
  {
    label: 'All',
    query: FILTER_TYPE.ALL,
  },
  {
    label: 'Profiles',
    query: FILTER_TYPE.ART,
  },
  {
    label: 'Culture',
    query: FILTER_TYPE.CULTURE,
  },
  {
    label: '101',
    query: FILTER_TYPE.SERVICE,
  },
];
